import APIAccessLog from "./APIAccessLog.page";

export default APIAccessLog;
